import {
  CLUB_MEMBERSHIP_LIST_REQUESTING,
  CLUB_MEMBERSHIP_OBJECT_REQUESTING,
  GET_CLUB_MEMBERSHIP_SUCCESS,
  GET_CLUB_MEMBERSHIP_SUCCESSV2,
  LIST_CLUB_MEMBERSHIPS_SUCCESS,
  LIST_CLUB_MEMBERSHIPS_SUCCESSV2,
  RESET_CLUB_MEMBERSHIP_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  dataV2: null,
  isObjectFetching: false,
  isListFetching: false,
  query: null,
  queryV2: null,
  recordCount: null,
  recordCountV2: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_MEMBERSHIP_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }

    case CLUB_MEMBERSHIP_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case CLUB_MEMBERSHIP_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_CLUB_MEMBERSHIPS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.clubMemberships.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        isListFetching: false
      };
    }
    case LIST_CLUB_MEMBERSHIPS_SUCCESSV2: {
      const dataV2 = { ...state.dataV2 };
      const queryV2 = [];
      action.payload.data.forEach((object) => {
        dataV2[object.id] = object;
        queryV2.push(object.id);
      });
      return {
        ...state,
        dataV2,
        queryV2,
        recordCountV2: action.payload.total,
        isListFetching: false
      };
    }
    case GET_CLUB_MEMBERSHIP_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    case GET_CLUB_MEMBERSHIP_SUCCESSV2: {
      const dataV2 = { ...state.dataV2 };
      dataV2[action.payload.id] = action.payload;
      return {
        ...state,
        dataV2,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getActiveAndOnHoldClubMemberships = (clubMembership) => {
  if (!clubMembership.data) {
    return null;
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const activeIds = clubMembershipIds.filter(
    (id) =>
      clubMembership.data[id].status === 'Active' ||
      clubMembership.data[id].status === 'On Hold'
  );
  return activeIds.map((id) => clubMembership.data[id]);
};

export const getCancelledClubMemberships = (clubMembership) => {
  if (!clubMembership.data) {
    return null;
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const cancelledIds = clubMembershipIds.filter(
    (id) => clubMembership.data[id].status === 'Cancelled'
  );
  return cancelledIds.map((id) => clubMembership.data[id]);
};
